import angular from 'angular';
import kformUtils from '../../utils/kform-utils';
import template from './repre.html';
import fbtemplate from './builder/preview.html';

const repreConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('repre', {
		title:                         'Repre',
		template,
		fbtemplate,
		group:                         'advanced',
		children:   false,
		selectable: true,
		settings:                      {
			add:       true,
			disabled:  false,
			hideLabel: true,
			input:     true,
			insert:    true,
			kdata:     {
				submit: false,
			},
			key:       'repre',
			label:     'Representation',
			forceView: '',
			tableView: false,
		},
		validate:                      {
			rules:                {},
		},
		event:                         {
			onChange: undefined,
		},
		icon:                          'fa fa-i-cursor',
		noDndOverlay:                  true,
		confirmRemove:                 true,
		views:                         [
			{
				name:     'Display',
				template: 'kform/components/repre/display.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/repre/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/repre/api.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
		controller:    /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.fbdata = [];

			if ($scope.options && $scope.options.building) {
				return;
			}

			$scope.changeValue = () => {
				if ($scope.component.event && typeof $scope.component.event.onChange === 'string') {
					const custom = ''.concat($scope.component.event.onChange, '; ');
					kformUtils.evaluate(custom, {
						data: $scope.data,
						form: $scope.form,
					});
				}
			};
		},
	});
};

export default angular.module('app').config(repreConfig);
